module.exports = __webpack_public_path__ + "static/media/sj.2aa40e45.svg";